module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/evank/Documents/dev/kyle.ventures/node_modules/axios/index.js
// module id = 152
// module chunks = 3